import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getLargestAvailableCoupon } from '../../../helpers';

// Components
import { Container } from 'reactstrap';
import LoyaltyCircle from '../../../../components/LoyaltyCircle';

// Images
import {ICON_COMPLETE, PROGRESS_COLOR} from "../../../../retailerValues";

class ProgressCircles extends Component {

  static propTypes = {
    bufferAmount: PropTypes.number.isRequired,
    tiers: PropTypes.arrayOf(PropTypes.number),
  }

  static defaultProps = {
    tiers: [1, 3, 6, 9]
  }

  getCircleTiersToDisplay() {
    const { bufferAmount, tiers } = this.props;
    const minTier = getLargestAvailableCoupon(bufferAmount);

    return tiers.filter(tier => tier >= minTier)
                .sort((a,b) => a > b); // ascending
  }

  renderProgressCircle(props) {
    return (
      <LoyaltyCircle
        {...props}
        className="ProgressCircles_circle"
        color={PROGRESS_COLOR}
        strokeWidth={5}
      />
    );
  }

  renderFullCircle(tier, key) {
    return (
      <div className="ProgressCircles_circle" key={key}>
        <img
          className="ProgressCircles_fullCircle_img"
          src={ICON_COMPLETE}
          alt={`$${tier} tier is full`}
        />

        <div className="ProgressCircles_fullCircle_shadow"></div>

        <div className="ProgressCircles_fullCircle_text">
          ${tier}
        </div>
      </div>
    );
  }

  renderCircles() {
    const { bufferAmount } = this.props;
    const finalTiers    = this.getCircleTiersToDisplay(); // i.e. if buffer = $4.89, returns [1, 3, 6, 9]
    var remainingBuffer = bufferAmount;

    return finalTiers.map((tier,i) => {
      // Full circle
      if (remainingBuffer >= tier) {
        remainingBuffer -= tier;
        return this.renderFullCircle(tier, i);
      }

      // Partially filled circle
      else if (remainingBuffer > 0) {
        let percentFull = remainingBuffer / tier * 100;
        remainingBuffer -= tier;

        return this.renderProgressCircle({
          key: i,
          text: '$' + tier, // i.e. $1, $3, $6, $9
          percentFull: percentFull,
        });
      }

      // Empty/Disabled circle
      else {
        remainingBuffer -= tier;
        return this.renderProgressCircle({
          key: i,
          text: '$' + tier, // i.e. $1, $3, $6, $9
          percentFull: 0,
          disabled: true
        });
      }
    });
  }

  render() {
    return (
      <div>
        <Container>
          <div className="ProgressCircles">

            {this.renderCircles()}

          </div>
        </Container>
      </div>
    );
  }
}

export default ProgressCircles;



// WEBPACK FOOTER //
// ./src/pages/Account/components/ProgressCircles/ProgressCircles.js